import './PrecheckResults.css';

import React, { FC, useCallback, useEffect, useState } from 'react';

import {
  PrecheckState,
  PrecheckPlaceholder,
  GenericStatus
} from 'vrlcm-gui-types';
import PrecheckValidationGroup from './PrecheckValidationGroup';
import Recommendations from './Recommendations';
import PrecheckGroupPlaceholder from './PrecheckGroupPlaceholder';

interface Props {
  state: PrecheckState;
  requestStatus: GenericStatus;
  placeholder?: PrecheckPlaceholder;
  onConsentChange: (consent: boolean) => void;
  initialCollapsed?: boolean;
}

interface Consent {
  [name: string]: boolean;
}

const PrecheckResults: FC<Props> = props => {
  const {
    state,
    requestStatus,
    placeholder,
    onConsentChange,
    initialCollapsed
  } = props;
  const { groups } = state;

  const initialGroupConsent = groups.reduce<Consent>((consent, group) => {
    return {
      ...consent,
      [group.name]: false
    };
  }, {});
  const [groupConsent, setGroupConsent] = useState(initialGroupConsent);
  const onGroupConsentChange = useCallback(
    (gName: string, v: boolean) =>
      setGroupConsent(p => ({
        ...p,
        [gName]: v
      })),
    []
  );
  useEffect(() => {
    const consentValues = Object.values(groupConsent);
    if (consentValues.length > 0) {
      const consent = consentValues.every(i => i);
      onConsentChange(consent);
    } else {
      onConsentChange(true);
    }
  }, [groupConsent, onConsentChange]);

  const [showRecommendations, setShowRecommendations] = useState(false);
  const [recommendations, setRecommendations] = useState<string[]>([]);

  const onshowRecommendations = (recos: string[]) => {
    setShowRecommendations(true);
    setRecommendations(recos);
  };

  const onCloseRecommendations = () => {
    setShowRecommendations(false);
    setRecommendations([]);
  };

  return (
    <div className="precheck-results">
      <div className="validation-groups">
        {requestStatus !== GenericStatus.Pending &&
          groups.map(group => {
            return (
              <PrecheckValidationGroup
                initialCollapsed={initialCollapsed}
                key={group.name}
                group={group}
                onClickRecommendations={onshowRecommendations}
                onConsentChange={onGroupConsentChange}
              />
            );
          })}
        {(requestStatus === GenericStatus.Pending ||
          requestStatus === GenericStatus.Running) &&
          placeholder
            ?.filter(
              group =>
                requestStatus === GenericStatus.Pending ||
                !groups.some(g => group.groupName === g.name)
            )
            .map(group => (
              <PrecheckGroupPlaceholder
                initialCollapsed={initialCollapsed}
                key={group.groupName}
                group={group}
              />
            ))}
      </div>
      {requestStatus !== GenericStatus.Pending && (
        <Recommendations
          recommendations={recommendations}
          open={showRecommendations}
          onClose={onCloseRecommendations}
        />
      )}
    </div>
  );
};

export default PrecheckResults;
